import { AbstractControl, ValidatorFn } from '@angular/forms';

export function GermanMobileNumberValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const isGermanMobileNumber = /^(\+49|0)1[5-7][0-9]{6,10}$/.test(control.value);
    return (!control.value || isGermanMobileNumber) ? null : { 'germanMobileNumber': { value: control.value } };
  };
}
